import {getAgentSignature} from '../../helpers/getAgentSignature';
import {highlightYellow} from '../../helpers/highlightYellow';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {getHowToReadQuotesVideo} from '../../helpers/getHowToReadQuotesVideo';
import {getNextStepsVideo} from '../../helpers/getNextStepsVideo';
import {
    emailHeaderCompanyLogo,
    quoteGreeting,
    quoteDiscussionReview,
    quoteIntroVideo,
    quoteNextSteps,
    aboutAmplify,
    illnessBrochure,
} from '../../helpers/commonEmailComponents';

export default function quoteGULTermBlend(params: QuoteTemplateParams) {
    const {
        name,
        face_amount: faceAmount,
        monthly_premium: monthlyPremium,
        brochureLink,
        illnessSection,
        term_period: termPeriod,
        life_coverage: lifeCoverage,
        life_premium: lifePremium,
    } = params;

    return `
${emailHeaderCompanyLogo}
<p>Hi ${highlightYellow(name)},</p>
${quoteGreeting}
${quoteDiscussionReview}
${quoteIntroVideo}
<p><strong>Our life insurance policies provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Coverage that lasts for the rest of your life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Pays out for life, critical, chronic, and terminal illness emergencies</span></li>
</ol>
<p><strong>Life insurance plan option for ${highlightYellow(name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        faceAmount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for the next ${highlightYellow(
        termPeriod,
    )} years, after ${highlightYellow(termPeriod)} years you will still have ${highlightYellow(
        lifeCoverage,
    )} remaining coverage for the rest of life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthlyPremium,
    )} per month (for the first ${highlightYellow(termPeriod)} years), after ${highlightYellow(
        termPeriod,
    )} years your premium drops to ${highlightYellow(lifePremium)} per month for rest of life</span></li>
</ul>
${getHowToReadQuotesVideo(params)}
${quoteNextSteps}
${getNextStepsVideo()}
${aboutAmplify}
${illnessBrochure(illnessSection, brochureLink)}
<p><span style="font-weight: 400;">Please let me know if you have any additional questions. Otherwise looking forward to speaking with you again ${highlightYellow(
        'on Friday',
    )} to help you find a plan that best fits your needs.</span></p>
<p><span style="font-weight: 400;">Best,</span></p>
${getAgentSignature()}
	`;
}
